<template>
  <div ref="wrapper" class="wrapper">
    <annotation
      class="annotator"
      :active-annotations="activeTodos"
      :annotations="todos"
      :src="image"
      :value="activeTodo"
      :disable-editor="true"
      :disable-overlay="true"
      :render-content="() => {}"
      :render-editor="() => {}"
      @[event].native.stop="onCanvasClick"
    />
  </div>
</template>

<script>
/**
	 * :on-change="onChange"
      :on-click="onClick"
      :on-submit="onSubmit"

	 *
	 * **/
import Annotation from 'react-image-annotation';
import { ReactInVue } from 'vuera';
import get_id from '../../utils/id';
import { mapState } from 'vuex';

export default {
  name: 'InImageTodoPicker',
  components: {
    annotation: ReactInVue(Annotation)
  },
  props: {
    image: String,
    enabled: {
      type: Boolean,
      default: true
    },
    initialTodos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      todos: this.initialTodos,
      activeTodo: {},
      activeTodos: []
    };
  },
  computed: {
    event() {
      return this.enabled ? 'dblclick' : null;
    },
    ...mapState('user', {
      email: state => state.me.email
    })
  },
  methods: {
    onCanvasClick(e) {
      let rect = e.target.getBoundingClientRect(),
        click_x = e.clientX - rect.left,
        click_y = e.clientY - rect.top,
        el_width = rect.width,
        el_height = rect.height,
        x = (click_x / el_width) * 100,
        y = (click_y / el_height) * 100,
        height = 1,
        width = 1,
        data = {
          text: 'Leerer Text',
          author: this.email
        };
      let task_id = get_id();
      let annotation = {
        geometry: {
          x,
          y,
          height,
          width,
          type: 'POINT'
        },
        data: {
          ...data,
          id: task_id,
          text: '',
          author: this.email
        },
        //status: STATI.BACKLOG,
        comments: [],
        needTextUpdate: true
      };
      this.todos = this.todos.concat(annotation);
      this.$emit('todo', annotation);
    }
  }
};
</script>

<style scoped>
.annotator {
  width: 100%;
  height: 100%;
}
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
